var render = function render(){var _vm=this,_c=_vm._self._c;return _c('logo',{attrs:{"id":"navigation-logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }